import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { LoginForm } from "../components";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/v2/card";

function LoginPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location, navigate]);

  const { passwordReset } = location.state || {};

  return (
    <Card className="w-full max-w-lg mx-auto shadow-lg">
      <CardHeader className="space-y-2 pb-4">
        <CardTitle>{t("common.signIn")}</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <LoginForm passwordResetSuccess={passwordReset === true} />
      </CardContent>
    </Card>
  );
}

export default LoginPage;
